export default "__VITE_ASSET__4ff7b598__"